import React from 'react';
import { FormattedMessage } from 'react-intl';

const renderApproveValue = (stats) => {
  const weekStat = stats.find((stat) => stat.period === 'week');

  const { rate, new: isNew } = weekStat;

  if (rate === undefined) return null;

  return isNew ? 'NEW' : rate === 0 ? '—' : rate + '%';
};

const OfferApprove = ({ stats }) => {
  const approveValue = renderApproveValue(stats);
  return approveValue ? (
    <div className="offer-approve-wrapper">
      <p className="offer-approve-title">
        <FormattedMessage id="offer.approve.title" defaultMessage="Average approval rate" />
      </p>
      <span className="offer-approve-value">{approveValue}</span>
    </div>
  ) : null;
};

export default OfferApprove;
